import { ref, computed, onMounted, watch } from '@vue/composition-api'
import _ from 'lodash'

export default function useFilteredNodeDataLevel(levelData, hideOthers = false) {
  const search = ref('')
  const showOthers = ref(true)

  const hasOthers = computed(() => {
    const children = _.get(levelData.value, ['children'], [])
    return children.some(node => node.isOther)
  })

  const filteredData = computed(() => {
    const children = _.get(levelData.value, ['children'], [])
    return children.filter(node => {
      const removeOther = _.isBoolean(node.isOther) && node.isOther && !showOthers.value
      if (removeOther) return false
      return node.name.toLowerCase().includes(search.value.toLowerCase())
    })
  })

  watch(search, (newVal) => {
    if(newVal) {
      showOthers.value = true
    }
  })

  onMounted(() => {
    if(hideOthers) showOthers.value = false
  })

  return {
    search,
    showOthers,
    hasOthers,
    filteredData
  }
}
